import { Link } from "react-router-dom";
import { Flower2, Home, Search } from "lucide-react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white text-[#222222]" data-testid="not-found-page">
      <Header />

      <section className="relative overflow-hidden bg-[#FBF9F4] border-b border-[#EAEAEA]">
        <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-[#A85C34]/5 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-[#D4A15C]/10 blur-3xl pointer-events-none" />

        <div className="frida-container relative py-24 md:py-32 flex flex-col items-center text-center">
          <div className="w-20 h-20 rounded-full bg-[#A85C34]/10 flex items-center justify-center mb-8">
            <Flower2 className="w-9 h-9 text-[#A85C34]" strokeWidth={1.5} />
          </div>

          <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-4">
            · 404 ·
          </div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1] max-w-2xl">
            Aradığınız Sayfa Solmuş Görünüyor
          </h1>
          <p className="mt-5 text-[#555555] text-lg max-w-lg leading-relaxed">
            Bu bağlantı artık geçerli değil ya da hiç var olmadı. Ama merak etmeyin,
            aradığınız çiçek koleksiyonlarımızın arasında sizi bekliyor olabilir.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-7 py-4 bg-[#A85C34] hover:bg-[#8f4c2a] text-white rounded-full font-medium transition-colors"
              data-testid="not-found-home-cta"
            >
              <Home className="w-4 h-4" />
              Ana Sayfaya Dön
            </Link>
            <Link
              to="/urunler"
              className="inline-flex items-center gap-2 px-7 py-4 bg-white border border-[#EAEAEA] hover:border-[#A85C34] text-[#222222] rounded-full font-medium transition-colors"
              data-testid="not-found-shop-cta"
            >
              <Search className="w-4 h-4" />
              Ürünleri Keşfet
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
